import React, { Component, PropTypes } from 'react';
import validator from 'validator';
import { v4 } from 'uuid';
import styled from 'styled-components';
import includes from 'lodash/includes';
import lowerCase from 'lodash/lowerCase';
import filter from 'lodash/filter';
import find from 'lodash/find';
import {
  Card,
  CardHeader,
  CardTitle,
  CardText,
  CardActions,
} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import Checkbox from 'material-ui/Checkbox';
import AutoComplete from 'material-ui/AutoComplete';
import DatePicker from 'material-ui/DatePicker';
import Chip from 'material-ui/Chip';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/action/delete';
import availStreams from '../../utils/streams';
import getLocations from '../../utils/locations';
import { database } from '../../utils/configureFirebase';
import { theme } from '../../utils/getTheme';

const ContentContainer = styled.div`
  width: 80%;
  margin: 0 auto;

  & > * + * {
    margin-top: 24px;
  }
`;

const ViewTitle = styled.div`
  padding: 16px 0;
  font-size: 32px;
  color: ${props => props.theme.textColor};
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CheckboxWrapper = styled.div`
display: flex;
`;

const CheckboxContainer = styled.div`
width: 50%;
`;

const CardIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 16px;
  opacity: 0.54;
`;


const styles = {
  TitleStyle: { paddingLeft: 0, paddingBottom: 0 },
};

class CreateDrive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUploader: false,
      isLoading: false,
      companyName: '',
      companyNameErrorMessage: undefined,
      companyType: '',
      companyTypeErrorMessage: undefined,
      website: '',
      websiteErrorMessage: undefined,
      companyDescription: '',
      showJobs: false,
      jobs: [],
      jobsErrorMessage: undefined,
      jobPosition: '',
      jobPositionErrorMessage: undefined,
      jobDescription: '',
      jobDescriptionErrorMessage: undefined,
      jobType: 'FTE',
      jobTypeErrorMessage: undefined,
      jobLocation: '',
      jobLocationErrorMessage: undefined,
      jobCtc: '',
      jobCtcErrorMessage: undefined,
      degreeText: '',
      degrees: [],
      degreesErrorMessage: undefined,
      streamSearchText: '',
      streams: [],
      streamsErrorMessage: undefined,
      skillText: '',
      skills: [],
      skillsErrorMessage: undefined,
      tests: [],
      testsErrorMessage: undefined,
      testString: '',
      locationSearchText: '',
      location: {},
      locationDataSource: [],
      locationErrorMessage: undefined,
      date: undefined,
      dateErrorMessage: undefined,
      lastRegdDate: undefined,
      lastRegdDateErrorMessage: undefined,
      notes: undefined,
      openConfirmModal: false,
    };

    this.databaseRef = undefined;
  }

  componentDidMount() {
    const { editable, driveId } = this.props;

    if (editable && driveId) {
      this.databaseRef = database.ref(`drives/${driveId}`);
      this.databaseRef.on('value', this.setDriveData);
    }
  }

  componentWillUnmount() {
    if (this.databaseRef) {
      this.databaseRef.off('value', this.setDriveData);
    }
  }

  setDriveData = (snapshot) => {
    if (snapshot) {
      const drive = snapshot.val();
      this.setState(() => ({
        ...drive,
        locationSearchText: drive.location.description,
        date: new Date(drive.date.year, drive.date.month, drive.date.date),
        lastRegdDate: new Date(drive.lastRegdDate.year,
          drive.lastRegdDate.month,
          drive.lastRegdDate.date,
        ),
      }));
    }
  }

  setLocation = (locationSelected) => {
    const { place_id, description } = locationSelected;
    this.changeStateValue('location', {
      place_id,
      description,
    });
  }

  getAvailStreams = () => {
    const { streams } = this.state;
    return availStreams.filter(stream => !find(streams, { stream }));
  }

  changeStateValue = (fieldName, value) => {
    const errorMessageField = `${fieldName}ErrorMessage`;
    const isErrorMessageFieldPresent = typeof this.state[errorMessageField];
    if (isErrorMessageFieldPresent) {
      this.setState(() => ({
        [fieldName]: value,
        [errorMessageField]: undefined,
      }));
    } else {
      this.setState(() => ({
        [fieldName]: value,
      }));
    }
  }

  addSkill = (skill) => {
    this.setState(state => ({
      skills: [
        ...state.skills,
        {
          id: v4(),
          skill,
        },
      ],
      skillText: '',
    }));
  }

  removeSkill = (id) => {
    this.setState(state => ({
      skills: filter(state.skills, skill => skill.id !== id),
    }));
  }

  addStream = (stream) => {
    this.setState(state => ({
      streams: [
        ...state.streams,
        {
          id: v4(),
          stream,
        },
      ],
      streamSearchText: '',
      streamsErrorMessage: undefined,
    }));
  }

  removeStream = (id) => {
    this.setState(state => ({
      streams: filter(state.streams, stream => stream.id !== id),
    }));
  }

  addDegree = (degree) => {
    this.setState(state => ({
      degrees: [
        ...state.degrees,
        degree,
      ],
      degreesErrorMessage: undefined,
    }));
  }

  removeDegree = (degree) => {
    this.setState(state => ({
      degrees: filter(state.degrees, val => val !== degree),
    }));
  }

  isDegreePresent = (degree) => {
    const { degrees } = this.state;
    return degrees.indexOf(degree) !== -1;
  }

  addTest = (test) => {
    this.setState(state => ({
      tests: [
        ...state.tests,
        test,
      ],
      testsErrorMessage: undefined,
    }));
  }

  removeTest = (test) => {
    this.setState(state => ({
      tests: filter(state.tests, val => val !== test),
    }));
  }

  isTestPresent = (test) => {
    const { tests } = this.state;
    return tests.indexOf(test) !== -1;
  }

  validadteInfo = () => {
    let isDirty = false;

    const {
      companyName,
      companyType,
      website,
      jobs,
      degrees,
      streams,
      skills,
      tests,
      location,
      date,
      lastRegdDate,
    } = this.state;

    // validation checks
    if (validator.isEmpty(companyName)) {
      this.changeStateValue('companyNameErrorMessage', 'Company name is required');
      isDirty = true;
    } else {
      this.changeStateValue('companyNameErrorMessage', undefined);
    }

    if (validator.isEmpty(companyType)) {
      this.changeStateValue('companyTypeErrorMessage', 'Company type is required');
      isDirty = true;
    } else {
      this.changeStateValue('companyTypeErrorMessage', undefined);
    }

    if (validator.isEmpty(website)) {
      this.changeStateValue('websiteErrorMessage', 'Company website is required');
      isDirty = true;
    } else {
      this.changeStateValue('websiteErrorMessage', undefined);
    }

    if (jobs.length === 0) {
      this.changeStateValue('jobsErrorMessage', 'Atleast one job is required');
      isDirty = true;
    } else {
      this.changeStateValue('jobsErrorMessage', undefined);
    }

    if (degrees.length === 0) {
      this.changeStateValue('degreesErrorMessage', 'Degree(s) is required');
      isDirty = true;
    } else {
      this.changeStateValue('degreesErrorMessage', undefined);
    }

    if (streams.length === 0) {
      this.changeStateValue('streamsErrorMessage', 'Stream(s) is required');
      isDirty = true;
    } else {
      this.changeStateValue('streamsErrorMessage', undefined);
    }

    if (skills.length === 0) {
      this.changeStateValue('skillsErrorMessage', 'Skill(s) is required');
      isDirty = true;
    } else {
      this.changeStateValue('skillErrorMessage', undefined);
    }

    if (tests.length === 0) {
      this.changeStateValue('testsErrorMessage', 'Test(s) is required');
      isDirty = true;
    } else {
      this.changeStateValue('testsErrorMessage', undefined);
    }


    const { place_id } = location;
    // eslint-disable-next-line
    if (typeof place_id === 'undefined' || validator.isEmpty(place_id)) {
      this.changeStateValue('locationErrorMessage', 'Campus location is required');
      isDirty = true;
    } else {
      this.changeStateValue('locationErrorMessage', undefined);
    }

    if (typeof date === 'undefined') {
      this.changeStateValue('dateErrorMessage', 'Campus date is required');
      isDirty = true;
    } else {
      this.changeStateValue('dateErrorMessage', undefined);
    }

    if (typeof lastRegdDate === 'undefined') {
      this.changeStateValue('lastRegdDateErrorMessage',
        'Last Registration date is required');
      isDirty = true;
    } else {
      this.changeStateValue('lastRegdDateErrorMessage', undefined);
    }

    return !isDirty;
  }

  validateDrive = () => {
    const isValid = this.validadteInfo();
    if (isValid) {
      this.setState(() => ({
        openConfirmModal: true,
      }));
    }

    this.moveToTop();
  }

  createDrive = () => {
    this.setState(() => ({
      showUploader: true,
      isLoading: true,
    }));

    const {
      companyName,
      companyDescription,
      jobs,
      website,
      companyType,
      degrees,
      streams,
      skills,
      tests,
      location,
      date,
      lastRegdDate,
      notes,
    } = this.state;

    const driveInfo = {
      companyName,
      companyDescription,
      jobs,
      website,
      companyType,
      degrees,
      streams,
      skills,
      tests,
      location,
      date: {
        date: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
      },
      lastRegdDate: {
        date: lastRegdDate.getDate(),
        month: lastRegdDate.getMonth(),
        year: lastRegdDate.getFullYear(),
      },
      notes: typeof notes === 'undefined' ? '' : notes,
    };

    const now = (new Date()).getTime();
    const driveId = v4() + now;

    const databaseRef = database.ref()
      .child(`drives/${driveId}`);

    databaseRef
      .set({
        ...driveInfo,
        timestamp: now,
      })
      .then(() => {
        this.setState(() => ({
          isLoading: false,
          openConfirmModal: false,
        }));
      });
  }

  updateDrive = () => {
    const isValid = this.validadteInfo();
    if (!isValid) {
      return;
    }

    this.setState(() => ({
      showUploader: true,
      isLoading: true,
    }));

    const {
      companyName,
      companyDescription,
      jobs,
      website,
      companyType,
      degrees,
      streams,
      skills,
      tests,
      location,
      date,
      lastRegdDate,
      notes,
      timestamp,
    } = this.state;

    const driveInfo = {
      companyName,
      companyDescription,
      jobs,
      website,
      companyType,
      degrees,
      streams,
      skills,
      tests,
      location,
      date: {
        date: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
      },
      lastRegdDate: {
        date: lastRegdDate.getDate(),
        month: lastRegdDate.getMonth(),
        year: lastRegdDate.getFullYear(),
      },
      notes,
    };

    const { driveId } = this.props;
    const databaseRef = database.ref(`drives/${driveId}`);

    databaseRef
      .update({
        ...driveInfo,
        timestamp,
      })
      .then(() => {
        this.setState(() => ({
          isLoading: false,
        }));
      });
  }

  resetForm = () => {
    const { history } = this.props;

    this.setState(() => ({
      showUploader: false,
      isLoading: false,
      companyName: '',
      companyNameErrorMessage: undefined,
      companyDescription: '',
      jobPosition: '',
      jobPositionErrorMessage: undefined,
      jobDescription: '',
      jobDescriptionErrorMessage: undefined,
      jobCtc: '',
      jobCtcErrorMessage: undefined,
      degrees: [],
      degreesErrorMessage: undefined,
      degreeText: '',
      streamSearchText: '',
      streams: [],
      streamsErrorMessage: undefined,
      skillText: '',
      skills: [],
      tests: [],
      testsErrorMessage: undefined,
      testString: '',
      locationSearchText: '',
      location: {},
      locationDataSource: [],
      locationErrorMessage: undefined,
      date: undefined,
      dateErrorMessage: undefined,
      lastRegdDate: undefined,
      lastRegdDateErrorMessage: undefined,
      notes: '',
    }), () => {
      history.push('/all');
    });
  }

  closeConfirmModal = () => {
    this.setState(() => ({
      openConfirmModal: false,
    }));
  }

  showJobs = () => {
    this.setState(() => ({
      showJobs: true,
    }));
  }

  hideJobs = () => {
    this.setState(() => ({
      showJobs: false,
      jobPosition: '',
      jobPositionErrorMessage: undefined,
      jobDescription: '',
      jobDescriptionErrorMessage: undefined,
      jobCtc: '',
      jobCtcErrorMessage: undefined,
      jobType: 'FTE',
      jobTypeErrorMessage: undefined,
      jobLocation: '',
      jobLocationErrorMessage: undefined,
    }));
  }

  addJobs = () => {
    const {
      jobPosition,
      jobDescription,
      jobCtc,
      jobType,
      jobLocation,
    } = this.state;

    let flag = false;

    if (validator.isEmpty(jobPosition)) {
      this.changeStateValue('jobPositionErrorMessage', 'Job Position is required');
      flag = true;
    } else {
      this.changeStateValue('jobPositionErrorMessage', undefined);
    }

    if (validator.isEmpty(jobDescription)) {
      this.changeStateValue('jobDescriptionErrorMessage', 'Job Desction is required');
      flag = true;
    } else {
      this.changeStateValue('jobDescriptionErrorMessage', undefined);
    }

    if (validator.isEmpty(jobCtc)) {
      this.changeStateValue('jobCtcErrorMessage', 'Job Ctc is required');
      flag = true;
    } else {
      this.changeStateValue('jobCtcErrorMessage', undefined);
    }

    if (validator.isEmpty(jobType)) {
      this.changeStateValue('jobTypeErrorMessage', 'Job Type is required');
      flag = true;
    } else {
      this.changeStateValue('jobTypeErrorMessage', undefined);
    }

    if (validator.isEmpty(jobLocation)) {
      this.changeStateValue('jobLocationErrorMessage', 'Job Location is required');
      flag = true;
    } else {
      this.changeStateValue('jobLocationErrorMessage', undefined);
    }

    if (!flag) {
      this.setState(state => ({
        jobs: [
          ...state.jobs,
          {
            id: v4(),
            jobPosition,
            jobDescription,
            jobCtc,
            jobType,
            jobLocation,
          },
        ],
        jobPosition: '',
        jobDescription: '',
        jobCtc: '',
        jobType: 'FTE',
        jobLocation: '',
        showJobs: false,
      }));
    }
  }

  removeJobs = (id) => {
    this.setState(state => ({
      jobs: state.jobs.filter(job => job.id !== id),
    }));
  }

  moveToTop = () => {
    document.getElementById('headerDiv').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  }

  render() {
    const {
      showUploader,
      isLoading,
      companyName,
      companyNameErrorMessage,
      website,
      websiteErrorMessage,
      companyDescription,
      companyType,
      companyTypeErrorMessage,
      showJobs,
      jobs,
      jobsErrorMessage,
      jobPosition,
      jobPositionErrorMessage,
      jobDescription,
      jobDescriptionErrorMessage,
      jobCtc,
      jobCtcErrorMessage,
      jobLocation,
      jobLocationErrorMessage,
      jobType,
      jobTypeErrorMessage,
      degreeText,
      degrees,
      degreesErrorMessage,
      streams,
      streamsErrorMessage,
      streamSearchText,
      skills,
      skillsErrorMessage,
      skillText,
      testsErrorMessage,
      locationSearchText,
      locationDataSource,
      locationErrorMessage,
      date,
      dateErrorMessage,
      lastRegdDate,
      lastRegdDateErrorMessage,
      notes,
      tests,
      testString,
      openConfirmModal,
    } = this.state;

    const { editable } = this.props;
    const todayDate = new Date();

    return (
      <ContentContainer id="headerDiv">
        {editable ? (<ViewTitle>Edit Drive</ViewTitle>) : (<ViewTitle>Create Drive</ViewTitle>)}

        <Card>
          <CardText style={{ paddingTop: 0 }}>
            <CardTitle
              title="Company Information"
              subtitle="Details about the hiring company"
              style={styles.TitleStyle}
            />
            <TextField
              floatingLabelText="Company Name *"
              fullWidth
              value={companyName}
              onChange={(_, value) => {
                this.changeStateValue('companyName', value);
              }}
              errorText={companyNameErrorMessage}
            />
            <SelectField
              floatingLabelText="Type of Company *"
              hintText="Select the type of comapny"
              fullWidth
              value={companyType}
              onChange={(_, index, value) => {
                this.changeStateValue('companyType', value);
              }}
              errorText={companyTypeErrorMessage}
            >
              <MenuItem primaryText="IT" value="IT" />
              <MenuItem primaryText="Non-IT" value="Non-IT" />
            </SelectField>

            <TextField
              floatingLabelText="Website *"
              hintText="enter the website of the company"
              fullWidth
              value={website}
              onChange={(_, value) => {
                this.changeStateValue('website', value);
              }}
              errorText={websiteErrorMessage}
            />

            <TextField
              floatingLabelText="About the Company"
              multiLine
              fullWidth
              value={companyDescription}
              onChange={(_, value) => {
                this.changeStateValue('companyDescription', value);
              }}
            />

            <CardTitle
              title="Job Details"
              subtitle={jobsErrorMessage}
              subtitleColor={theme.accent1Color}
              style={styles.TitleStyle}
            />

            {jobs.length !== 0 ? (
              <div>
                {jobs.map(job => (
                  <Card key={job.id} style={{ position: 'relative' }}>
                    <CardHeader
                      title={job.jobPosition}
                      subtitle={`${job.jobType} | ${job.jobCtc} | ${job.jobLocation}`}
                    />
                    <CardIcon>
                      <IconButton>
                        <CloseIcon color={theme.primary1Color} onTouchTap={() => { this.removeJobs(job.id); }} />
                      </IconButton>
                    </CardIcon>
                  </Card>
                ))}
              </div>
            ) : null}

            {showJobs ? (
              <div>
                <TextField
                  floatingLabelText="Job Title *"
                  hintText="Software Developer"
                  fullWidth
                  value={jobPosition}
                  onChange={(_, value) => {
                    this.changeStateValue('jobPosition', value);
                  }}
                  errorText={jobPositionErrorMessage}
                />

                <TextField
                  floatingLabelText="Job Description *"
                  hintText="Brief description about the job"
                  fullWidth
                  multiLine
                  value={jobDescription}
                  onChange={(_, value) => {
                    this.changeStateValue('jobDescription', value);
                  }}
                  errorText={jobDescriptionErrorMessage}
                />

                <SelectField
                  floatingLabelText="Employment Type *"
                  fullWidth
                  value={jobType}
                  onChange={(_, index, value) => {
                    this.changeStateValue('jobType', value);
                  }}
                  errorText={jobTypeErrorMessage}
                >
                  <MenuItem primaryText="Full Time Employment" value="FTE" />
                  <MenuItem primaryText="Internship" value="INTERNSHIP" />
                </SelectField>

                {jobType === 'FTE' ? (
                  <TextField
                    floatingLabelText="Cost To Company *"
                    hintText="Enter in numerals or alphabets"
                    fullWidth
                    value={jobCtc}
                    onChange={(_, value) => {
                      this.changeStateValue('jobCtc', value);
                    }}
                    errorText={jobCtcErrorMessage}
                  />
                ) : (
                    <TextField
                      floatingLabelText="Stipened *"
                      hintText="Enter in numerals or alphabets"
                      fullWidth
                      value={jobCtc}
                      onChange={(_, value) => {
                        this.changeStateValue('jobCtc', value);
                      }}
                      errorText={jobCtcErrorMessage}
                    />
                  )}
                <TextField
                  floatingLabelText="Job Location *"
                  hintText="Enter the location"
                  fullWidth
                  value={jobLocation}
                  onChange={(_, value) => {
                    this.changeStateValue('jobLocation', value);
                  }}
                  errorText={jobLocationErrorMessage}
                />
                <CardActions>
                  <RaisedButton label="Save" primary onTouchTap={() => { this.addJobs(); }} />
                  <FlatButton label="Cancel" primary onTouchTap={() => { this.hideJobs(); }} />
                </CardActions>
              </div>

            ) : (
                <CardActions style={{ paddingTop: 8 }}>
                  <RaisedButton label="Add Job" primary onTouchTap={() => { this.showJobs(); }} />
                </CardActions>
              )}

            <CardTitle
              title="Eligibility Criteria"
              style={styles.TitleStyle}
            />
            <CardHeader
              title="Degrees Eligible *"
              subtitle={degreesErrorMessage || 'Select all applicable'}
              subtitleColor={degreesErrorMessage && '#F44336'}
              style={styles.TitleStyle}
            />

            <CheckboxWrapper>
              <CheckboxContainer>
                <Checkbox
                  label="B.Tech / B.E."
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('B.Tech / B.E.');
                    } else {
                      this.removeDegree('B.Tech / B.E.');
                    }
                  }}
                  checked={this.isDegreePresent('B.Tech / B.E.')}
                />
                <Checkbox
                  label="BBA"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('BBA');
                    } else {
                      this.removeDegree('BBA');
                    }
                  }}
                  checked={this.isDegreePresent('BBA')}
                />
                <Checkbox
                  label="BCA"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('BCA');
                    } else {
                      this.removeDegree('BCA');
                    }
                  }}
                  checked={this.isDegreePresent('BCA')}
                />
                <Checkbox
                  label="B.Sc"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('B.Sc');
                    } else {
                      this.removeDegree('B.Sc');
                    }
                  }}
                  checked={this.isDegreePresent('B.Sc')}
                />

                <Checkbox
                  label="Diploma"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('Diploma');
                    } else {
                      this.removeDegree('Diploma');
                    }
                  }}
                  checked={this.isDegreePresent('Diploma')}
                />

              </CheckboxContainer>

              <CheckboxContainer>
                <Checkbox
                  label="M.Tech / M.E."
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('M.Tech / M.E.');
                    } else {
                      this.removeDegree('M.Tech / M.E.');
                    }
                  }}
                  checked={this.isDegreePresent('M.Tech / M.E.')}
                />

                <Checkbox
                  label="MBA"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('MBA');
                    } else {
                      this.removeDegree('MBA');
                    }
                  }}
                  checked={this.isDegreePresent('MBA')}
                />

                <Checkbox
                  label="MCA"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('MCA');
                    } else {
                      this.removeDegree('MCA');
                    }
                  }}
                  checked={this.isDegreePresent('MCA')}
                />

                <Checkbox
                  label="MSc"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('MSc');
                    } else {
                      this.removeDegree('MSc');
                    }
                  }}
                  checked={this.isDegreePresent('MSc')}
                />

                <Checkbox
                  label="P.G. Diploma"
                  onCheck={(_, isChecked) => {
                    if (isChecked) {
                      this.addDegree('P.G. Diploma');
                    } else {
                      this.removeDegree('P.G. Diploma');
                    }
                  }}
                  checked={this.isDegreePresent('P.G. Diploma')}
                />
              </CheckboxContainer>

            </CheckboxWrapper>
            <TextField
              fullWidth
              floatingLabelText="Type any other missing degree"
              value={degreeText}
              onChange={(_, value) => {
                this.changeStateValue('degreeText', value);
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 13) {
                  this.addDegree(degreeText);
                  this.setState(() => ({
                    degreeText: '',
                  }));
                }
              }}
            />
            <ChipsContainer>
              {degrees.map(degree => (
                <Chip
                  key={degree}
                  style={{
                    marginRight: 8,
                    marginBottom: 8,
                  }}
                  onRequestDelete={() => {
                    this.removeDegree(degree);
                  }}
                >
                  {degree}
                </Chip>
              ))}
            </ChipsContainer>
            <AutoComplete
              hintText="Type stream and press enter to select"
              dataSource={this.getAvailStreams()}
              filter={(searchText, key) =>
                includes(lowerCase(key), lowerCase(searchText))
              }
              searchText={streamSearchText}
              onUpdateInput={(searchText) => {
                this.changeStateValue('streamSearchText', searchText);
              }}
              floatingLabelText="Stream Eligible *"
              onNewRequest={(streamSelected) => {
                this.addStream(streamSelected);
              }}
              errorText={streamsErrorMessage}
              fullWidth
            />
            <ChipsContainer>
              {streams.map(stream => (
                <Chip
                  key={stream.id}
                  onRequestDelete={() => {
                    this.removeStream(stream.id);
                  }}
                  style={{
                    marginRight: 8,
                    marginBottom: 8,
                  }}
                >
                  {stream.stream}
                </Chip>
              ))}
            </ChipsContainer>
            <TextField
              floatingLabelText="Skills Required *"
              hintText="Programming Languages, Soft skills, etc. Press Enter to add"
              fullWidth
              value={skillText}
              onChange={(_, value) => {
                this.changeStateValue('skillText', value);
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 13) {
                  this.addSkill(this.state.skillText);
                }
              }}
              errorText={skillsErrorMessage}
            />
            <ChipsContainer>
              {skills.map(skill => (
                <Chip
                  key={skill.id}
                  onRequestDelete={() => {
                    this.removeSkill(skill.id);
                  }}
                  style={{
                    marginRight: 8,
                    marginBottom: 8,
                  }}
                >
                  {skill.skill}
                </Chip>
              ))}
            </ChipsContainer>

            <CardTitle
              title="Event Details"
              subtitle="Date and Venue of the drive"
              style={styles.TitleStyle}
            />
            <CardHeader
              title="Rounds *"
              subtitle={testsErrorMessage || 'Select all applicable'}
              subtitleColor={testsErrorMessage && '#F44336'}
              style={styles.TitleStyle}
            />
            <Checkbox
              label="Online Test"
              checked={this.isTestPresent('Online Test')}
              onCheck={(_, isChecked) => {
                if (isChecked) {
                  this.addTest('Online Test');
                } else {
                  this.removeTest('Online Test');
                }
              }}
            />
            <Checkbox
              label="Group Discussion"
              checked={this.isTestPresent('Group Discussion')}
              onCheck={(_, isChecked) => {
                if (isChecked) {
                  this.addTest('Group Discussion');
                } else {
                  this.removeTest('Group Discussion');
                }
              }}
            />
            <Checkbox
              label="Technical Round"
              checked={this.isTestPresent('Technical Round')}
              onCheck={(_, isChecked) => {
                if (isChecked) {
                  this.addTest('Technical Round');
                } else {
                  this.removeTest('Technical Round');
                }
              }}
            />
            <Checkbox
              label="Final Round"
              checked={this.isTestPresent('Final Round')}
              onCheck={(_, isChecked) => {
                if (isChecked) {
                  this.addTest('Final Round');
                } else {
                  this.removeTest('Final Round');
                }
              }}
            />
            <Checkbox
              label="Offer Rollout"
              checked={this.isTestPresent('Offer Rollout')}
              onCheck={(_, isChecked) => {
                if (isChecked) {
                  this.addTest('Offer Rollout');
                } else {
                  this.removeTest('Offer Rollout');
                }
              }}
            />
            <TextField
              floatingLabelText="Additional Tests"
              fullWidth
              value={testString}
              onChange={(_, value) => {
                this.changeStateValue('testString', value);
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 13) {
                  this.addTest(testString);
                  this.setState(() => ({
                    testString: '',
                  }));
                }
              }}
            />

            <ChipsContainer>
              {tests.map(test => (
                <Chip
                  key={test}
                  style={{
                    marginRight: 8,
                    marginBottom: 8,
                  }}
                  onRequestDelete={() => {
                    this.removeTest(test);
                  }}
                >
                  {test}
                </Chip>
              ))}
            </ChipsContainer>


            <AutoComplete
              floatingLabelText="Campus Venue *"
              hintText="Enter the exact location to search"
              dataSource={locationDataSource}
              fullWidth
              onUpdateInput={(locationSearchString) => {
                this.changeStateValue('locationSearchText', locationSearchString);
                getLocations(locationSearchString)
                  .then((data) => {
                    this.setState(() => ({
                      locationDataSource: data,
                    }));
                  })
                  .catch(() => { });
              }}
              dataSourceConfig={{
                text: 'description',
                value: 'place_id',
              }}
              filter={AutoComplete.fuzzyFilter}
              onNewRequest={this.setLocation}
              errorText={locationErrorMessage}
              searchText={locationSearchText}
            />
            <InputRow>
              <DatePicker
                floatingLabelText="Campus Date *"
                formatDate={inputDate => (inputDate ? date.toDateString() : undefined)}
                hintText="Campus Date*"
                onChange={(_, dateSelected) => {
                  this.changeStateValue('date', dateSelected);
                }}
                errorText={dateErrorMessage}
                value={date}
                minDate={todayDate}
                style={{ width: '48%' }}
                fullWidth
              />
              <DatePicker
                floatingLabelText="Last Registeration Date *"
                formatDate={inputDate => (inputDate ? inputDate.toDateString() : undefined)}
                hintText="Last Registration Date*"
                onChange={(_, dateSelected) => {
                  this.changeStateValue('lastRegdDate', dateSelected);
                }}
                errorText={lastRegdDateErrorMessage}
                value={lastRegdDate}
                style={{ width: '48%' }}
                fullWidth
              />
            </InputRow>

            <CardTitle
              title="Notes"
              style={styles.TitleStyle}
            />

            <TextField
              floatingLabelText="Notes"
              hintText="Additional notes and remarks"
              multiLine fullWidth
              value={notes}
              onChange={(_, value) => {
                this.changeStateValue('notes', value);
              }}
            />
          </CardText>
          <CardActions>
            {editable ? (
              <RaisedButton
                primary
                label="Update Drive"
                onTouchTap={this.updateDrive}
              />
            ) : ( // eslint-disable-next-line
                <RaisedButton
                  primary
                  label="Create Drive"
                  onTouchTap={this.validateDrive}
                />
              )}
          </CardActions>
        </Card>

        <Dialog
          open={showUploader}
          modal
          title="Creating Drive"
          actions={isLoading ? undefined : [
            <FlatButton
              primary
              label="Continue"
              onTouchTap={this.resetForm}
            />,
          ]}
        >
          {isLoading ? (
            <DialogContent>
              <CircularProgress />
              <p>
                Posting data to the server...
              </p>
            </DialogContent>
          ) : ( // eslint-disable-next-line
              <p>
                Drive Form is succesfully created. Go to <b>Saved Drives</b> to see details.
            </p>
            )}
        </Dialog>
        <Dialog
          title="Create Drive"
          modal
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.closeConfirmModal}
            />,
            <RaisedButton
              label="Create"
              primary
              onTouchTap={this.createDrive}
            />,
          ]}
          open={openConfirmModal}
          onRequestClose={this.closeConfirmModal}

        >
          <CardText>
            Please Confirm all the details before submitting.
          </CardText>
        </Dialog>
      </ContentContainer>
    );
  }
}

CreateDrive.propTypes = {
  editable: PropTypes.bool,
  driveId: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

CreateDrive.defaultProps = {
  editable: false,
  driveId: undefined,
};

export default CreateDrive;



// WEBPACK FOOTER //
// ./src/views/CreateDrive/CreateDrive.js